import { Component, Host, h, Element, Prop } from "@stencil/core";

/**
 * @slot - Slot for any content
 */
@Component({
  tag: "stzh-content",
  styleUrl: "stzh-content.scss",
  scoped: true,
})
export class StzhContent {
  /** Variant */
  @Prop({ reflect: true }) variant: "default" | "shifted" | "full" = "default";

  /** Prevent changing layout of elements within this content element */
  @Prop({ reflect: true }) preventElementLayout = false;

  @Element() element: HTMLStzhContentElement;

  render() {
    const classes = {
      "stzh-content": true,
      [`stzh-content--${this.variant}`]: !!this.variant,
    };

    return (
      <Host>
        <div class={classes}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
